import { Component, Input, inject } from '@angular/core';
import { HisUiService } from 'hisng';

/*  const pDialogKey for InformationDialogComponent */
export const INFORMATION_PDIALOG_KEY = 'informationDialogKey';

@Component( {
    selector: 'psv-information-dialog',
    templateUrl: './information-dialog.component.html',
    standalone: false
} )

export class InformationDialogComponent {
    private hisUiService = inject(HisUiService);

    @Input() width = 850;
    public pDialogKey; // key of <p-confirmDialog>

    constructor() {
        this.pDialogKey = INFORMATION_PDIALOG_KEY; // set default const key
    }
}
